import React from 'react'
import { Navigate } from 'react-router-dom';
import { useAuth } from './../hooks/useAuth';

export const PrivateRoutes = ({children}) => {

  const { user } = useAuth();
  
  return (
    
    (user) ? children : <Navigate to={'/login'} />
  )
}
